module.exports = __webpack_public_path__ + "pages.items.instagram-940de8e8.html";